// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"35a39898","132":"583984fb","134":"d81f9ad0","259":"e407181f","334":"3657e4ec","453":"a4e47e56","458":"ec4256b3","787":"278b9736"}[chunkId] + ".chunk.js";
};